import { MapStateToPropsParam } from "react-redux";

import {
    BlogsImageDetailPage,
    BlogsImageDetailViewType,
    OwnProps,
    Props,
    RouteProps,
    StateProps,
} from "@/mk2/apps/blogs/containers/BlogsImageDetail/BlogsImageDetailPage";
import { blogsAlbumDetailUrl } from "@/mk2/apps/blogs/urls";
import { url } from "@/mk2/helpers/urls";
import { AppState } from "@/mk2/reducers";

export default class BlogsAlbumImageDetailPage extends BlogsImageDetailPage {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {
                ...(super.mapStateToProps()(state, ownProps) as StateProps),
                viewType: BlogsImageDetailViewType.Album,
            };
        };
    }

    public getDefaultBackPath(props: Props): string {
        const {
            match: {
                params: { username, postSlug },
            },
        } = props;
        return url(blogsAlbumDetailUrl, { username, postSlug });
    }
}
